import Checkbox from '@material-ui/core/Checkbox';

import Checked from './Checked.svg';
import Unchecked from './Unchecked.svg';

export default (props) => (
  <Checkbox checkedIcon={<Checked />} icon={<Unchecked />} {...props} />
);
